<template>
  <ValidationProvider v-slot="{ errors }" tag="div" :rules="rules" :vid="vid">
    <slot :error="errors[0]" />
    <FieldValidationError
      v-if="!customValidation && errors[0]"
      :is-static="isStaticError"
    >
      {{ errors[0] }}
    </FieldValidationError>
  </ValidationProvider>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  components: {
    FieldValidationError: () => import('@/components/FieldValidationError.vue'),
  },
})
export default class FormControl extends Vue {
  @Prop({ type: String, required: true }) rules!: string;
  @Prop({ type: String }) vid?: string;
  @Prop({ type: Boolean, default: false }) customValidation?: boolean;
  @Prop({ type: Boolean, default: false }) isStaticError?: boolean;
}
</script>
